/**
 * Hand bytes to the visitor as a file. A blob URL and an `<a download>`: no
 * request leaves the page, so it works with no network, and the URL is revoked
 * once the browser has had time to take it (Safari reads it after the click
 * returns, so not at once).
 */
export function saveFile(data: BlobPart, name: string, type: string): void {
  const url = URL.createObjectURL(new Blob([data], { type }));
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
